module.exports = __webpack_public_path__ + "static/img/1831_phase_function_Paper_PointsHejduk_Prediction.117a37c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1831_phase_function_Paper_PointsHejduk_Prediction.png
// module id = kgJY
// module chunks = 0